export enum WalletStatusEnum {
	ServiceProvider,
	Client,
}
export const WalletStatus: {
	name: string
	value: string
	count: number
	showCount: boolean
}[] = []

Object.keys(WalletStatusEnum).forEach((value: string) =>
	isNaN(+value)
		? WalletStatus.push({
				name: value,
				value: WalletStatusEnum[value as any],
				count: 0,
				showCount: false,
		  })
		: null
)

export enum WalletTransactionActorEnum {
	Client = 1,
	ServiceProvider = 2,
	Admin = 3,
}
